import "../../../../../../fonts/DpIcons/dp.css";
import React from "react";
import LauncherButton from "@/components/launcher/LauncherButton";
import { TranslationContextProvider } from "./lib/client/contexts/TranslationContext";
import { useSessionContext } from "./lib/client/contexts/SessionContext";

export default function LocaleLayout({
  params,
  children,
}: {
  params: { tenantId: string; messengerId: string; hostConfig: string; locale: string };
  children: React.ReactNode;
}) {
  const { session } = useSessionContext();

  return (
    <TranslationContextProvider locale={params.locale}>
      {children}
      {!session && <LauncherButton params={params} messengerId={params.messengerId} />}
    </TranslationContextProvider>
  );
}
